$(document).ready(function () {
  message = "Give a $50 gift card. Click here to redeem.";
  if ($('#customer_id').val() > 0){
  
    if ($("#giftcard_earned").val() == "true") {
      console.log("Customer needs GC popup");
      $("#MainContent").prepend("<div class='promo-banner gc'>" + message + "</div>");
    } else {
      console.log("Customer does not need GC popup");
  }
}
});
